// extracted by mini-css-extract-plugin
export default {"title":"quizTopAppBar_title__eg5gi","small-font":"quizTopAppBar_small-font__7CixN","large-font":"quizTopAppBar_large-font__8wWeB"};